<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query }"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <div class="tags-actions">
      <el-tooltip content="关闭全部标签" placement="bottom">
        <el-button type="text" icon="el-icon-circle-close" class="close-all-btn" @click="closeAllTags($route)">关闭全部</el-button>
      </el-tooltip>
    </div>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭全部</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane.vue'

export default {
  name: 'TagsView',
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {}
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.getters.permissionRoutes
    }
  },
  watch: {
    $route() {
      this.addTags()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    // 清理历史刷新产生的无效标签
    const junk = this.visitedViews.filter(v =>
      !v.title || v.title === 'no-name' || v.name === 'Redirect' || (v.path && String(v.path).indexOf('/redirect') === 0)
    )
    junk.forEach(v => this.$store.dispatch('tagsView/delVisitedView', v))
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = route.path.startsWith('/') ? route.path : `${basePath}/${route.path}`.replace(/\/+/g, '/')
          tags.push({ fullPath: tagPath, path: tagPath, name: route.name, meta: { ...route.meta } })
        }
        if (route.children) {
          const childBase = route.path === '/' ? '/' : `${basePath}/${route.path}`.replace(/\/+/g, '/')
          tags = tags.concat(this.filterAffixTags(route.children, childBase))
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const route = this.$route
      if (!route.name) return
      if (route.name === 'Redirect') return
      if (route.path && route.path.indexOf('/redirect') === 0) return
      if (route.meta && route.meta.hidden) return
      if (!route.meta || !route.meta.title) return
      this.$store.dispatch('tagsView/addView', route)
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag)
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath || latestView.path)
      } else {
        this.$router.push('/')
      }
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const path = view.path || this.$route.path
        const query = view.query || this.$route.query
        this.$nextTick(() => {
          this.$router.replace({ path: '/redirect' + path, query }).catch(() => {})
        })
      })
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left
      let left = e.clientX - offsetLeft + 15
      if (left > this.$el.offsetWidth - menuMinWidth) {
        left = this.$el.offsetWidth - menuMinWidth
      }
      this.left = left
      this.top = e.clientY - 40
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: $tags-height;
  width: 100%;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(22, 93, 255, 0.05);
  display: flex;
  align-items: center;

  .tags-actions {
    flex-shrink: 0;
    padding: 0 12px 0 4px;
  }
  .close-all-btn {
    color: #86909c;
    font-size: 13px;
    padding: 0 6px;
    &:hover { color: $primary; }
  }

  .tags-view-wrapper {
    flex: 1;
    min-width: 0;
    .tags-view-item {
      display: inline-flex;
      align-items: center;
      position: relative;
      cursor: pointer;
      height: 30px;
      line-height: 30px;
      border: 1px solid transparent;
      color: #4e5969;
      background: #f3f6fb;
      padding: 0 12px;
      font-size: 13px;
      margin-left: 8px;
      margin-top: 0;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:first-of-type { margin-left: 18px; }

      &:hover {
        color: $primary;
        background: rgba($primary, 0.08);
      }

      &.active {
        background: rgba($primary, 0.12);
        color: $primary;
        border-color: rgba($primary, 0.18);
        font-weight: 600;

        &::before {
          content: '';
          background: $primary;
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 6px;
        }
      }

      .el-icon-close {
        width: 16px;
        height: 16px;
        margin-left: 4px;
        border-radius: 50%;
        text-align: center;
        line-height: 16px;
        transition: all 0.2s;

        &:hover {
          background-color: rgba($primary, 0.2);
          color: $primary;
        }
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.12);
    li {
      margin: 0;
      padding: 8px 16px;
      cursor: pointer;
      &:hover { background: #f5f7fa; color: $primary; }
    }
  }
}
</style>
